 // v=46730312834640058591595002786
theme.library = v=46730312834640058591595002786;
theme.crr_library = localStorage.getItem('library') || '[]';
theme.strings = {
  inStock: "Disponible",
  outOfStock: "No disponible",
  soldOut: "Agotado",
  addToCart: "Agregar al carrito",
  addedToCart: "Agregado",
  contact: "Contacto",
  remove: "Eliminar",
  empty: "Tu carrito está vacío",
  cartItem: "Tienes \u003cspan class='text-bold'\u003e(1 item)\u003c\/span\u003e en tu carrito",
  cartItems: "Tienes \u003cspan class='text-bold'\u003e(2 item)\u003c\/span\u003e en tu carrito",
  cartItemText: "item",
  cartItemsText: "items",
  titleTotal: "Subtotal",
  noimage: "\/\/cdn.shopify.com\/s\/files\/1\/0436\/2662\/7240\/t\/2\/assets\/noimage.gif?1675",
  infoButton: "Información",
  customButton: "Personalizar",
  cdday: "Días",
  cdhrs: "Horas",
  cdmin: "Minutos",
  cdsecs: "Segundos",
  nll_error_mesenger: "No se pudo registrar. Inténtalo de nuevo",
  nll_success_mesenger: "Gracias por suscribirte",
  aspect_ratio: "277/377",
  search_dropdown_pages: "Páginas",
  search_dropdown_articles: " Desde",
  search_dropdown_no_results: "Tu búsqueda no pudo encontrar resultados"
};
theme.productStrings = {
  sizeGuide: "Tamaño",
  addToCart: "Agregar al carrito",
  preOrder: "Pre-ordenar",
  selectOption: "Selecciona una opción",
  soldOut: "Agotado",
  inStock: "Disponible",
  outOfStock: "No disponible",
  unavailable: "No disponible",
  onlyLeft: 'Sólo quedan <span>1</span>',
  onSale: 'Ofertas',
  stockMessage: ["¡Date prisa! Solo quedan "," disponibles."],
  label_select: "Seleccionar a",
  viewMoreVariants: "Más",
  addToWishlist: "Agregar a mi lista de deseos",
  viewWishlist: "Ver mi lista de deseos"
};
theme.function = {
  multiCurrency: true,
  autoCurrency: false,
  searchAjax: true,
  searchByCollection: true,
  searchAjaxTypes: "product,page,article",
  vrsgallery: true,
  quickshop: "true",
  quickview: true,
  fquickview: "false",
  use_am_popup: false,
  use_thumb_hidden_on_mb: false,
  productImgType: "normal",
  productOptionStyle: [{'name': "Color",'style': "not_select square",'color_watched': true,'op_attach': false,'op_pre_select': false},{'name': "Size",'style': "combobox",'color_watched': false,'op_attach': true,'op_pre_select': false},{'name': "Style",'style': "combobox with_out_variant_image",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "Model",'style': "combobox with_out_variant_image",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "",'style': "not_select circle",'color_watched': false,'op_attach': false,'op_pre_select': false}],
  productGridOptionStyle: [{'name': "Color",'style': "circle _small",'color_watched': true, 'sw_style': "color"},{'name': "Size",'style': "square _small",'color_watched': false, 'sw_style': "color"},{'name': "Material",'style': "list list_1",'color_watched': false, 'sw_style': "color"},{'name': "Model",'style': "square",'color_watched': true, 'sw_style': "color"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "color"}],
  photoZoom: false,
  nll_ajax: true,
  type_ajax_cart: "drawer",
  ajax_cart_page: true,
  sticky_icon_cart: null,
  textInListShipping: "translation missing: es.products.delivery.text_in_list",
  textInListShippingMax: "translation missing: es.products.delivery.text_in_list_max",
  product_delivery: {
    offSaturday: true,
    offSunday: true,
    offDays: ["23\/12\/****","24\/12\/****","01\/01\/****","02\/11\/2019"],
    fromDate: 10,
    toDate: 19 
  },
  countdown_timezone: false,
  timezone: 'America/Mexico_City',
  timenow: {
    h: "23",
    i: "59",
    s: "60",
    timeNow: "2022/06/24",
    hNow: "17",
    iNow: "56",
    sNow: "06"
  }
};
theme.compare = {
  remove: "Eliminar"
};
theme.gadget = {
  cookies_infor: false,
  newsletter_popup: true,
  shipTo: true
};

theme.suggest = {
  enable: false,
  collection_opj: "",
  delay_time: 15000,
  show_time: 7600,
  use_fake_location: true,
  arr_fake_location: ["Melbourne, Australia","Washington","Nevada"]
};

theme.extensions = {
  ktToolsCss: '//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/ktTools.scss.css?v=22945105168615461471595002834',
  ktToolsJs: '//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/ktTools.js?v=23518685763435140231595002834',
  ktToolsSlideshowJs: '//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/ktTools.slideshow.js?v=105372855331814478391595002833',
  adminThemeTool: '//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/adminThemeTool.scss.css?v=26032429354608457171595002739',
  ktToolsSettingsPreset: '//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/settings_preset.js?1675'
}

const firstLink = document.getElementsByTagName("link")[0];
const headDocument = document.head;
const bodyDocument = document.body;

if (theme.crr_library.length == 0) {
  localStorage.setItem('library','[]');
}

window._handleize = function(str){
  str = str.toLowerCase().replace(/'|"|\(|\)|\[|\]/g, "").replace(/\W+/g, "-")
  return str.replace(/^-+|-+$/g, "")
}
window._snakeCase = function(str){
  str = str.toLowerCase().replace(/'|"|\(|\)|\[|\]/g, "").replace(/\W+/g, "_")
  return str.replace(/^-+|-+$/g, "")
}

"undefined" == typeof KT && (KT = {});
KT.checkVersion = function(name_item){
  name_item = name_item.split('/')[name_item.split('/').length - 1];
  var version = false;
  if(!localStorage.getItem(name_item)){
    version = true; 
  }
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
      version = true;
    }
  } else if(libs_ver.findIndex(function(obj){ return obj.name == name_item}) === -1){
    version = true;
  }
  return version; 
}
KT.pushVersion = function(name_item){
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
    }
  }
  else {
    var obj = {
      name : name_item,
      ver : theme.library
    }
    libs_ver.push(obj);
    localStorage.setItem('library',JSON.stringify(libs_ver));
  }
  theme.crr_library = localStorage.getItem('library') || '[]';
}
KT.loadScript = function(id, callback) {
  let css_url = "";
  let js_url = "";
  let done = false;
  // var file_name_css = '';
  if($('#'+id).length || $('#'+id).length){
    checkExists(id, js_url)
  }
  else {
    if(id == 'magnific-popup' && $('#magnific-popup-css').length <= 0){
      css_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/magnific-popup.min.css?v=57525974320827922071595002760";
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.magnific-popup.min.js?v=184369421263510081681595002753";
    }
    else if(id == 'threesixty' && $('#threesixty-css').length <= 0){
      css_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/threesixty.min.css?v=110917158222743342331595002788";
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/threesixty.min.js?v=128470061555666291351595002788";
    }
    else if(id == 'photo-swipe' && $('#photo-swipe-css').length <= 0){
      css_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/photoswipe-ui.min.css?v=50182594455179234001595002769";
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/photoswipe-ui.min.js?v=89145670203526742621595002769";
    }
    else if(id == 'YTPlayer'){
      css_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.mb.YTPlayer.min.css?v=59914316629707384691595002754";
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.mb.YTPlayer.min.js?v=127366606670431650381595002754";
    }
    else if(id == 'swiper'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/swiper.min.js?v=25016689274377554141595002779";
    }
    else if(id == 'pjax'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.pjax.min.js?v=96510263879411166301595002755";
    }
    else if(id == 'imagesloaded'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/imagesloaded.pkgd.min.js?v=147859183389955144291595002747";
    }
    else if(id == 'isotope'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/isotope-plus.pkgd.min.js?v=139088845446234680461595002749";
    }
    else if(id == 'instafeed'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/instafeed.min.js?v=167375059766121062631595002748";
    }
    else if(id == 'countdown'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.countdown.min.js?v=116994322243221080931595002750";
    }
    else if(id == 'countto'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.countTo.min.js?v=148382760188409556611595002750";
    }
    else if(id == 'moment'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/moment.min.js?v=96302747854271246571595002765";
    }
    else if(id == 'moment-zone'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/moment-timezone-with-data.min.js?v=28936048893783064501595002765";
    }
    else if(id == 'momentlocale'){
      if (shopLocale === 'en') {handleLoad(); return}
      js_url = "//cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/locale/"+shopLocale+".js";
    }
    else if(id == 'zoom'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.zoom.min.js?v=127655014540499679121595002756";
    }
    else if(id == 'parallax'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.parallax_mousemove.js?v=79184343061227765141595002755";
    }
    else if(id == 'tippy'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/tippy-bundle.iife.min.js?v=119878756178377760041595002789";
    }
    else if(id == 'color_sw'){
      css_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/swatch-color.css?v=87112208204652398511595002779";
    }
    else if(id == 'animate'){
      css_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/animate.min.css?v=20349278028107590831595002739";
    }
    else if(id == 'molla_icon'){
      css_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/molla-icon.css?v=143551970315193154961595611378";
    }
    else if(id == 'adminThemeCss'){
      css_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/adminThemeTool.scss.css?v=26032429354608457171595002739";
    }
    else if(id == 'shopify-currency'){
      js_url = "//cdn.shopify.com/s/javascripts/currencies.js";
    }
    else if(id == 'shipping'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/jquery.currency-shipping.min.js?v=77586439398839307371595002752";
    }
    else if(id == 'plyr'){
      css_url = "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.1/shopify-plyr.css";
      js_url = "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.en.js";
    }
    else if(id == 'shopify-xr'){
      js_url = "//cdn.shopify.com/shopifycloud/shopify-xr-js/v1.0/shopify-xr.en.js";
    }
    else if(id == 'model-viewer-ui'){
      css_url = "//cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css";
      js_url = "//cdn.shopify.com/shopifycloud/model-viewer-ui/v1.0/model-viewer-ui.en.js";
    }
    else if(id == 'theme-alert'){
      js_url = "//cdn.shopify.com/s/files/1/0436/2662/7240/t/2/assets/theme-alert.js?v=160511086935636528771595968422";
    }
    done = false;
    ajaxLoad(id, css_url, js_url);
  }
  function ajaxLoad(name, css_url, js_url){
    if(css_url !== ''){
      var scr_css = document.createElement('link');
      scr_css.type = 'text/css';
      scr_css.rel = "stylesheet";
      scr_css.cache = true;
      scr_css.id = name+'-css';
      scr_css.href = css_url;
      scr_css.onerror = function() {
        alert("Error loading css " + this.href);
      };
      headDocument.insertBefore(scr_css, firstLink);
    }
    if(js_url !== ''){
      var scr_js = document.createElement('script');
      scr_js.type = 'text/javascript';
      scr_js.cache = true;
      scr_js.async = true;
      scr_js.src = js_url;
      scr_js.id = name;
      scr_js.onload = checkExists(name, js_url);
      scr_js.onerror = function() {
        alert("Error loading js " + this.src);
      };
      bodyDocument.appendChild(scr_js);
    }
  }
  function checkExists(id, js_url){
    var callbackTimer = setInterval(function() {
      if (id == 'swiper' && typeof Swiper === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'owl-carousel' && typeof $.fn.owlCarousel === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'slick-slide' && typeof $.fn.slick === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'moment' && typeof moment === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'moment-zone' && typeof moment.tz === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }      
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'imagesloaded' && typeof $.fn.imagesLoaded === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'isotope' && typeof $.fn.isotope === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'YTPlayer' && typeof jQuery.fn.YTPlayer === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'parallax' && typeof $.fn.mouseMove === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countdown' && typeof $.fn.countdown === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countto' && typeof $.fn.countTo === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'instafeed' && typeof Instafeed == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'momentlocale' && moment.locale() == shopLocale){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'zoom' && typeof $.fn.zoom == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'pjax' && typeof $.fn.pjax == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'photo-swipe' && typeof PhotoSwipe == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'threesixty' && typeof $.fn.ThreeSixty == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'tippy' && typeof tippy == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shipping' && typeof Kt_currency.convertAll == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shopify-currency' && typeof Currency !== "undefined") {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'plyr' && typeof Shopify.Plyr == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'shopify-xr' && typeof ShopifyXR !== 'undefined') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'model-viewer-ui' && typeof Shopify.ModelViewerUI == 'function' ) {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'theme-alert' && typeof KT_Alert !== "undefined" ) {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
    }, 100);
  }
  function handleLoad() {
    if (!done) {
      done = true;
      // console.log(js_url)
      callback(js_url, "ok");
    }
  }
}